var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlarmOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alarm_x5F_Off"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.73,4.606l-4.198-2.157l0.396-0.767c0.336-0.661,1.059-0.97,1.606-0.687l2.212,1.134 c0.547,0.281,0.718,1.047,0.378,1.709L18.73,4.606z M20.771,12.158c0,2.947-1.453,5.556-3.682,7.146l1.297,2.811 c0,0,0.057,0.496-0.435,0.736c-0.533,0.266-0.912-0.084-0.912-0.084l-1.276-2.681c-1.142,0.543-2.416,0.847-3.764,0.847 c-1.347,0-2.623-0.304-3.762-0.847L6.96,22.77c0,0-0.379,0.351-0.912,0.084c-0.492-0.238-0.436-0.735-0.436-0.735l1.299-2.812 c-2.229-1.59-3.684-4.197-3.684-7.146c0-4.846,3.928-8.775,8.774-8.775C16.848,3.385,20.771,7.312,20.771,12.158z M12.001,5.315 c-3.777,0-6.837,3.062-6.837,6.841c0,3.777,3.061,6.841,6.837,6.841c3.774,0,6.836-3.062,6.836-6.841S15.775,5.315,12.001,5.315z  M15.514,10.362l-2.285,2.287l2.285,2.281c0.35,0.35,0.35,0.918-0.003,1.271c-0.35,0.352-0.919,0.352-1.268,0.002l-2.285-2.284 l-2.285,2.284c-0.351,0.353-0.918,0.35-1.27-0.002c-0.351-0.351-0.351-0.919-0.001-1.269l2.286-2.283l-2.285-2.287 c-0.35-0.35-0.35-0.917,0.001-1.269c0.351-0.351,0.919-0.351,1.27-0.001l2.284,2.284l2.285-2.285 c0.349-0.35,0.918-0.35,1.268,0.001C15.861,9.444,15.861,10.012,15.514,10.362z M4.856,3.833c-0.339-0.659-0.169-1.42,0.38-1.7 l2.211-1.128c0.55-0.281,1.272,0.026,1.61,0.684l0.395,0.763L5.25,4.598L4.856,3.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlarmOff);
export default __webpack_public_path__ + "static/media/ic_alarm_off.8003af92ec3f840e60069fd0c1cb3715.svg";
export { ForwardRef as ReactComponent };